import { Language } from '@data/index';

export const initialTranslations: { [key in Language]: string } = Object.values(Language).reduce(
  (acc, key) => {
    acc[key as Language] = '';
    return acc;
  },
  {} as { [key in Language]: string },
);
